import TheGrid from '@/views/scorecard/independents/operators/grid'
import Edit from '@/views/scorecard/independents/operators/edit'

export default {
  path: '/scorecard-independents/operators',
  redirect: '/scorecard-independents/operators/index',
  name: 'scIndependentOperators',
  meta: {
    auth: {
      redirect: {
        name: 'scIndependentOperators.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Independentes'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'scIndependentOperators.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'scIndependentOperators.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'scIndependentOperators.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
